import React, { createContext, useEffect, useMemo, useRef } from "react";
import useBulkTravelServiceInformation from "../../hooks/useBulkTravelServiceInformation";
import mapTSILegsToTSIJourney from "../../utils/TSI/mapTSILegsToTSIJourney";
const JourneyContext = createContext(null);
JourneyContext.displayName = "JourneyContext";
const JourneyProvider = ({
  journey,
  onInitializationStart,
  onInitializationCompleted,
  onRefetchStart,
  onRefetchCompleted,
  onFetchError,
  disableFetch,
  children
}) => {
  const { data, isLoading, isFetching, isError, isSuccess, dataUpdatedAt, error } = useBulkTravelServiceInformation(journey, disableFetch);
  const tsiLegs = useMemo(() => {
    var _a;
    return (_a = data == null ? void 0 : data.v1_bulkTravelServiceInformation) == null ? void 0 : _a.results;
  }, [data]);
  const legsRef = useRef(journey.legs);
  const lastUpdatedRef = useRef(0);
  legsRef.current = journey.legs;
  const isInitializing = isLoading;
  const isRefetching = isFetching && !isLoading;
  useEffect(() => {
    if (isInitializing) {
      onInitializationStart == null ? void 0 : onInitializationStart();
    } else if (isRefetching) {
      onRefetchStart == null ? void 0 : onRefetchStart();
    }
  }, [isInitializing, isRefetching, onInitializationStart, onRefetchStart]);
  useEffect(() => {
    if (isSuccess && tsiLegs) {
      const isInitialFetch = lastUpdatedRef.current === 0;
      if (isInitialFetch) {
        onInitializationCompleted == null ? void 0 : onInitializationCompleted(tsiLegs);
      } else {
        onRefetchCompleted == null ? void 0 : onRefetchCompleted(tsiLegs);
      }
      lastUpdatedRef.current = dataUpdatedAt;
    }
  }, [tsiLegs, isSuccess, dataUpdatedAt, onInitializationCompleted, onRefetchCompleted]);
  useEffect(() => {
    if (isError && error) {
      onFetchError == null ? void 0 : onFetchError(error);
    }
  }, [error, isError, onFetchError]);
  const contextValue = useMemo(() => ({
    isInitializing,
    isRefetching,
    journey,
    tsiJourney: mapTSILegsToTSIJourney(legsRef.current, tsiLegs)
  }), [isRefetching, isInitializing, journey, tsiLegs]);
  return /* @__PURE__ */ React.createElement(JourneyContext.Provider, {
    value: contextValue
  }, children);
};
var JourneyProvider_default = JourneyProvider;
export {
  JourneyContext,
  JourneyProvider_default as default
};
